import React from "react";
import QueryString from "query-string";
import PaginaTitulo from "./components/PaginaTitulo";
import Rodape from "./components/Rodape";
import AppState from "./model/AppState";
import SeletorLoja from "./components/SeletorLoja";
import BuscaProdutos from "./components/BuscaProdutos";
import ListaItens from "./components/ListaItens";
import ConteudoModel from "./model/ConteudoModel";
import ProdutoModel from "./model/ProdutoModel";
import MockData from "./model/MockData";
import C5ProdutoDAO from "./dataAccess/C5/C5ProdutoDAO";
import WPBuscaDAO from "./dataAccess/WP/WPBuscaDAO";
import LojaModel from "./model/LojaModel";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Carregando from "./components/Carregando";

interface IBuscaProps extends RouteComponentProps {}

type BuscaState = {
  produtos: ProdutoModel[];
  conteudos: ConteudoModel[];
  carregandoProdutos: boolean;
  carregandoConteudo: boolean;
  concluido: boolean;
  selecionado: string;
  query: string;
  mostrar: number;
};

class Busca extends React.Component<IBuscaProps, BuscaState> {
  constructor(props: IBuscaProps) {
    super(props);

    this.showProdutos = this.showProdutos.bind(this);
    this.showConteudos = this.showConteudos.bind(this);
    this.carregaProdutos = this.carregaProdutos.bind(this);
    this.exibeLoader = this.exibeLoader.bind(this);
    this.ocultaLoader = this.ocultaLoader.bind(this);
    this.mostrarMais = this.mostrarMais.bind(this);

    let query: any;
    query = QueryString.parse(this.props.location.search);

    this.state = {
      produtos: [],
      conteudos: [],
      carregandoProdutos: true,
      carregandoConteudo: true,
      concluido: true,
      selecionado: "produtos",
      query: query.q,
      mostrar: 10,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Busca");

    this.carregaProdutos();
  }

  carregaProdutos(): void {
    let query: any;
    query = QueryString.parse(this.props.location.search);

    if (AppState.getMockData()) {
      this.setState({
        produtos: MockData.getProdutos(),
        conteudos: MockData.getConteudos(),
        carregandoProdutos: false,
        carregandoConteudo: false,
      });
    } else {
      this.setState({ query: query.q, carregandoProdutos: true });
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      if (loja) {
        C5ProdutoDAO.getInstance()
          .getBuscaProdutos(query.q, "", loja.lojaId)
          .then((prods: ProdutoModel[]) =>
            this.setState({
              produtos: prods,
              carregandoProdutos: false,
              concluido: true,
              query: query.q,
            })
          ).catch((ex) => {
            LogUtil.log(ex);
            this.setState({
              carregandoProdutos: false,
              concluido: true,
            })
          });
      } else {
        NavegadorUtil.redirect("/lojas", this.props.history);
      }

      WPBuscaDAO.getInstance()
        .getBusca(query.q, false)
        .then((conteudos: ConteudoModel[]) => {
          this.setState({
            conteudos,
            carregandoConteudo: false,
          });
        });
    }
  }

  showProdutos(): any {
    this.setState({ selecionado: "produtos" });
  }

  showConteudos(): any {
    this.setState({ selecionado: "inspirese" });
  }

  exibeLoader(): any {
    this.setState({ carregandoProdutos: true });
  }

  ocultaLoader(): any {
    this.setState({ carregandoProdutos: false });
  }

  mostrarMais() {
    this.setState({ mostrar: this.state.mostrar + 10 });
  }


  render(): any {
    const {
      selecionado,
      conteudos,
      concluido,
      carregandoConteudo,
      carregandoProdutos,
    } = this.state;
    let { produtos, mostrar } = this.state;
    let query: any;
    query = QueryString.parse(this.props.location.search);
    const title: string = `Resultados de busca para <br /> "${query.q}"`;

    if (this.state.query !== query.q) {
      this.carregaProdutos();
    }

    if (query.q && query.q.length > 0) {
      const prodCopy: ProdutoModel[] = JSON.parse(
        JSON.stringify(produtos)
      ) as ProdutoModel[];

      produtos = [];
      produtos = produtos.concat(
        prodCopy.filter((p) =>
          p.nome.toLowerCase().startsWith(query.q.toLowerCase())
        )
      );
      produtos = produtos.concat(
        prodCopy.filter(
          (p) => !p.nome.toLowerCase().startsWith(query.q.toLowerCase())
        )
      );
    }

    let produtosMostrar = JSON.parse(JSON.stringify(produtos));

    produtosMostrar.length = mostrar;

    return (
      <section className="home has-footer">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        <BuscaProdutos onChangeText={null} parent={this}></BuscaProdutos>
        <PaginaTitulo titulo={title}></PaginaTitulo>
        <ul className="main-menu">
          <li
            className={`${
              selecionado === "produtos" ? "active " : ""
            } products`}
            onClick={this.showProdutos}
          >
            Produtos
          </li>
          <li
            className={`${
              selecionado === "inspirese" ? "active " : ""
            } inspire`}
            onClick={this.showConteudos}
          >
            <i className="far fa-heart"></i> Inspire-se
          </li>
        </ul>
        {selecionado === "produtos" && (
          <div ref="prods">
            <ListaItens
              produtos={produtosMostrar}
              carregando={carregandoProdutos}
              parent={this}
              concluido={concluido}
            ></ListaItens>
            { mostrar < produtos.length &&
            <button onClick={this.mostrarMais} className="main-button">
              Mostrar mais
            </button>
            }
          </div>
        )}
        {selecionado === "inspirese" && (
          <div ref="conts">
            <ListaItens
              conteudos={conteudos}
              carregando={carregandoConteudo}
              parent={this}
              concluido={concluido}
              ></ListaItens>
          </div>
        )}
        <Carregando exibir={carregandoProdutos} concluido={concluido}></Carregando>
        <Rodape parent={this} ativo="Home"></Rodape>
      </section>
    );
  }
}

export default withRouter(Busca);
